module.exports = __webpack_public_path__ + "img/logo_amazon.6a86f4f0.png";